"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.Breadcrumb = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconClickable = require("../../Elements/IconClickable/IconClickable");
var _jsxRuntime = require("react/jsx-runtime");
function breadcrumbItem(key, className, child, hasSeparator) {
  if (hasSeparator) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
        className: className,
        children: child
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
        className: `${className} ccl-e-breadcrumb__item__separator`,
        children: "/"
      })]
    }, key);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
    className: className,
    children: child
  }, key);
}
const Breadcrumb = props => {
  const {
    items,
    itemCssModifier,
    routerLink: Link
  } = props;
  const itemLength = items.length;
  const breadcrumbs = items.map((item, index) => {
    const {
      linkTo,
      handleClick,
      text,
      id
    } = item;
    const key = `breadcrumb__item__${id || index}`;
    if (index + 1 < itemLength) {
      // has another sibling
      if (index === 0) {
        // render root item
        const className = `ccl-e-breadcrumb__item ccl-e-breadcrumb__item--root ccl-e-breadcrumb__item--${itemCssModifier}`;
        return breadcrumbItem(key, className, /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconClickable.IconClickable, {
          id: "Back",
          leftIcon: {
            rotate: '',
            flip: '',
            disabled: false,
            type: 'north',
            size: 'sm',
            color: 'interactive'
          },
          lblContainerCssModifier: "inline",
          link: linkTo ? {
            to: linkTo
          } : null,
          handleClick: handleClick,
          text: text,
          routerLink: Link
        }), true);
      }

      // render child item  with separator
      const className = `ccl-e-breadcrumb__item ccl-e-breadcrumb__item--child ccl-e-breadcrumb__item--${itemCssModifier}`;
      return breadcrumbItem(key, className, /*#__PURE__*/(0, _jsxRuntime.jsx)(Link, {
        className: className,
        "data-nw-action": id,
        to: linkTo,
        onClick: handleClick,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: text
        })
      }), true);
    }

    // render current item
    const className = `ccl-e-breadcrumb__item ccl-e-breadcrumb__item--current ccl-e-breadcrumb__item--${itemCssModifier}`;
    return breadcrumbItem(key, className, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: text
    }), false);
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
    className: "ccl-e-breadcrumb",
    children: breadcrumbs
  });
};
exports.Breadcrumb = Breadcrumb;
Breadcrumb.defaultProps = {
  itemCssModifier: 'primary',
  routerLink: undefined
};